import React from "react";
import { Grid } from "react-virtualized";

function getHeight() {
  return Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.documentElement.clientHeight
  );
}

function getWidth() {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  );
}

// Render your grid
function Masonry({ list, customCellRenderer }) {
  const newList = [];

  list.forEach((item, i) => {
    // 0, 3, 6
    // 1, 4, 7
    // 2, 5, 8
    const index = Math.floor(i / 3);
    if (!newList[index]) {
      newList[index] = [];
    }
    if (i % 3 === 0) {
      newList[index][0] = item;
    } else if (i % 3 === 1) {
      newList[index][1] = item;
    } else if (i % 3 === 2) {
      newList[index][2] = item;
    }
  });

  function cellRenderer({ columnIndex, key, rowIndex, style }) {
    const datum = newList[rowIndex][columnIndex];
    return (
      datum && (
        <div key={key} style={style}>
          {customCellRenderer(datum, rowIndex * columnIndex)}
        </div>
      )
    );
  }

  const windowWidth = getWidth();
  const windowHeight = getHeight();
  return (
    <Grid
      cellRenderer={cellRenderer}
      columnCount={newList[0].length}
      columnWidth={windowWidth / 3}
      height={windowHeight - 115 - 51} // 115 header height + 51 search
      rowCount={newList.length}
      rowHeight={350}
      width={windowWidth}
    />
  );
}

export { Masonry };



// WEBPACK FOOTER //
// ./src/components/widgets/Masonry.js